var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.$router.currentRoute.name,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('FooterElem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }